(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bf-month-banner"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('cz-bf-banner')) {
    class CZBFMonthBanner extends HTMLElement {
      connectedCallback() {
        if (this.abortController) return;
        this.abortController = new AbortController();
        const options = { signal: this.abortController.signal };
        this.panels = Array.from(this.querySelectorAll('[data-panel]'));
        this.editor = this.dataset.editor === 'true';
        this.status = this.querySelector('[data-status]');
        this.note = this.querySelector('[data-editor-note]');
        this.selectedId = null;
        this.copyVersion = 0;
        this.addEventListener('click', event => {
          const button = event.target.closest('[data-copy-button]');
          if (button && this.contains(button)) this.copyCode(button);
        }, options);
        document.addEventListener('visibilitychange', () => {
          if (!document.hidden) this.refresh();
        }, options);
        window.addEventListener('pageshow', () => this.refresh(), options);
        if (this.editor) {
          document.addEventListener('shopify:block:select', event => {
            const panel = this.panels.find(item => item.dataset.panel === event.detail?.blockId);
            if (panel) { this.selectedId = panel.dataset.panel; this.refresh(); }
          }, options);
          document.addEventListener('shopify:block:deselect', event => {
            if (event.detail?.blockId === this.selectedId) { this.selectedId = null; this.refresh(); }
          }, options);
        }
        this.refresh();
      }
      disconnectedCallback() {
        this.abortController?.abort();
        this.abortController = null;
        clearTimeout(this.scheduleTimer);
        clearTimeout(this.copyTimer);
        this.copyVersion++;
      }
      parseTime(value) {
        if (!/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(?:Z|[+-]\d{2}:\d{2})$/.test(value || '')) return NaN;
        const parts = value.slice(0, 19).split(/[-T:]/).map(Number);
        const [year, month, day, hour, minute, second] = parts;
        const days = new Date(Date.UTC(year, month, 0)).getUTCDate();
        if (year < 2020 || month < 1 || month > 12 || day < 1 || day > days || hour > 23 || minute > 59 || second > 59) return NaN;
        return Date.parse(value);
      }
      period(panel) {
        const start = this.parseTime(panel.dataset.start);
        const end = this.parseTime(panel.dataset.end);
        return { panel, start, end, valid: panel.dataset.enabled === 'true' && !!panel.dataset.code?.trim() && Number.isFinite(start) && Number.isFinite(end) && end > start };
      }
      refresh() {
        if (!this.isConnected) return;
        clearTimeout(this.scheduleTimer);
        const now = Date.now();
        const periods = this.panels.filter(panel => panel.dataset.panel !== 'manual').map(panel => this.period(panel));
        const matches = periods.filter(period => period.valid && now >= period.start && now < period.end);
        let active = this.dataset.mode === 'manual' ? this.panels.find(panel => panel.dataset.panel === 'manual' && panel.dataset.code.trim()) : matches[0]?.panel;
        const livePanel = active;
        if (this.editor) {
          active = this.panels.find(panel => panel.dataset.panel === this.selectedId) || active || (this.dataset.mode === 'scheduled' ? (periods[0]?.panel || this.panels[0]) : this.panels[0]);
          if (this.note) {
            this.note.textContent = active === livePanel ? 'Anteprima del banner attualmente visibile sul sito.' : 'Solo anteprima editor: questo periodo non è attualmente visibile sul sito. Verifica attivazione, date e codice.';
            if (this.dataset.mode === 'scheduled' && matches.length > 1) this.note.textContent += ' Periodi sovrapposti: sul sito ha precedenza il primo nell’elenco.';
          }
        }
        if (this.currentPanel !== active) {
          this.copyVersion++;
          clearTimeout(this.copyTimer);
          this.status.textContent = '';
          this.status.classList.remove('czbf-status--error');
          this.panels.forEach(panel => {
            panel.hidden = panel !== active;
            panel.querySelector('[data-copy-label]').textContent = this.dataset.copy;
          });
          this.currentPanel = active;
        }
        this.hidden = !active;
        if (this.dataset.mode === 'scheduled') {
          const next = periods.filter(period => period.valid).flatMap(period => [period.start, period.end]).filter(time => time > now);
          const wait = next.length ? Math.max(50, Math.min(60000, Math.min(...next) - now + 50)) : 60000;
          this.scheduleTimer = setTimeout(() => this.refresh(), wait);
        }
      }
      async copyCode(button) {
        const panel = button.closest('[data-panel]');
        const code = panel.dataset.code;
        if (!code || button.disabled) return;
        const version = ++this.copyVersion;
        clearTimeout(this.copyTimer);
        let success = false;
        try {
          if (navigator.clipboard?.writeText) { await navigator.clipboard.writeText(code); success = true; }
        } catch { success = false; }
        if (!this.isConnected || version !== this.copyVersion || panel !== this.currentPanel) return;
        if (!success) {
          const selection = window.getSelection();
          const range = document.createRange();
          range.selectNodeContents(button.querySelector('.czbf-code'));
          selection.removeAllRanges();
          selection.addRange(range);
          try { success = document.execCommand('copy'); } catch { success = false; }
          if (success) selection.removeAllRanges();
        }
        const label = button.querySelector('[data-copy-label]');
        label.textContent = success ? this.dataset.copied : this.dataset.failed;
        this.status.classList.toggle('czbf-status--error', !success);
        this.status.textContent = (success ? this.dataset.copied : this.dataset.failed) + ': ' + code;
        if (success) this.copyTimer = setTimeout(() => {
          if (this.isConnected && version === this.copyVersion) { label.textContent = this.dataset.copy; this.status.textContent = ''; }
        }, 1500);
      }
    }
    customElements.define('cz-bf-banner', CZBFMonthBanner);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bfcm-popup-cultivator"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('cz-bfcm-popup')) {
  customElements.define('cz-bfcm-popup', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      queueMicrotask(() => {
        if (!this.isConnected || this.initialized) return;
        this.initialize();
      });
    }
    initialize() {
      const config = this.querySelector('[data-bfcm-config]');
      if (!config) return;
      try { this.config = JSON.parse(config.textContent); } catch { return; }
      this.initialized = true;
      this.controller = new AbortController();
      this.started = performance.now();
      this.lastClock = this.started;
      this.wasVisible = !document.hidden;
      this.pageReadyAt = this.started + 2000;
      this.deferUntil = 0;
      this.baseTime = Number(this.config.serverTime) || Date.now();
      this.dialog = this.querySelector('dialog');
      this.form = this.querySelector('form');
      this.strings = this.config.strings;
      this.phases = this.config.phases.map(p => ({ id: p.id, ...p.settings }));
      this.pending = this.read('pending', true);
      this.phase = this.choosePhase();
      this.loadVisit();
      this.bind();
      this.timer = setInterval(() => this.tick(), 500);
      if (!this.phase) return;
      this.render();
      const state = this.querySelector('[data-form-status]').dataset.formStatus;
      const hasPending = this.pending && this.now() - this.pending.time < 1800000;
      const hasAnchor = location.hash === '#' + this.config.formId;
      if (!this.config.editor && (hasPending || hasAnchor) && state === 'success') {
        this.write('submitted', this.now());
        this.erase('pending', true);
        this.pending = null;
        this.cleanReturnUrl();
        this.showSuccess();
        this.open('result');
      } else if (!this.config.editor && (hasPending || hasAnchor) && state === 'error') {
        this.erase('pending', true);
        this.pending = null;
        this.open('result');
        const details = this.querySelector('[data-newsletter]');
        details.hidden = false;
        details.open = true;
      } else if (this.config.editor && this.config.editorOpen) {
        this.open('editor');
      }
      this.tick();
    }
    disconnectedCallback() {
      if (this.initialized) this.saveVisitClock(true);
      this.controller?.abort();
      clearInterval(this.timer);
      clearTimeout(this.cartTimer);
      clearTimeout(this.submitTimer);
      if (this.dialog?.open) this.dialog.close();
      this.unlockScroll();
      this.initialized = false;
    }
    now() { return this.baseTime + performance.now() - this.started; }
    read(key, session = false) {
      try { return JSON.parse((session ? sessionStorage : localStorage).getItem(this.config.key + ':' + key)); } catch { return null; }
    }
    write(key, value, session = false) {
      if (this.config.editor) return;
      try { (session ? sessionStorage : localStorage).setItem(this.config.key + ':' + key, JSON.stringify(value)); } catch {}
    }
    erase(key, session = false) {
      if (this.config.editor) return;
      try { (session ? sessionStorage : localStorage).removeItem(this.config.key + ':' + key); } catch {}
    }
    loadVisit() {
      const saved = this.read('popup_v2:visit', true);
      if (saved && Number.isFinite(saved.lastSeen) && this.now() - saved.lastSeen < 1800000) {
        this.visit = { activeMs: Math.max(0, Number(saved.activeMs) || 0), lastSeen: saved.lastSeen, shown: !!saved.shown };
      } else {
        this.visit = { activeMs: 0, lastSeen: this.now(), shown: false };
      }
      this.write('popup_v2:visit', this.visit, true);
    }
    saveVisitClock(force = false) {
      if (!this.visit || this.config.editor) return;
      const clock = performance.now();
      const now = this.now();
      const expired = !this.wasVisible && !document.hidden && now - this.visit.lastSeen >= 1800000;
      if (expired) this.visit = { activeMs: 0, lastSeen: now, shown: false };
      if (this.wasVisible) this.visit.activeMs += Math.max(0, clock - this.lastClock);
      this.lastClock = clock;
      this.wasVisible = !document.hidden;
      if (!document.hidden) this.visit.lastSeen = now;
      if (force || !this.persistedAt || clock - this.persistedAt >= 1000) {
        this.write('popup_v2:visit', this.visit, true);
        this.persistedAt = clock;
      }
    }
    isSubscriber() {
      return !this.config.editor && (!!this.config.customerSubscribed || !!this.read('submitted'));
    }
    exposureKey() {
      const p = this.phase;
      return 'popup_v2:offer:' + [p.key, p.mode, p.discount, p.tier, p.minimum, p.code || ''].join('|');
    }
    recordExposure() {
      if (this.config.editor || !this.phase) return;
      this.visit.shown = true;
      this.lastExposure = this.now();
      this.lastExposureKey = this.exposureKey();
      this.write(this.lastExposureKey, this.lastExposure);
      this.saveVisitClock(true);
    }
    text(selector, value) {
      const node = this.querySelector(selector);
      if (node) node.textContent = value || '';
    }
    format(value, extra = {}) {
      const p = this.phase || {};
      const map = { discount: p.discount, tier: p.tier, minimum: p.minimum, ...extra };
      return String(value || '').replace(/\[([a-z_]+)\]/g, (all, key) => map[key] ?? all);
    }
    choosePhase() {
      if (!this.config.enabled && !this.config.editor) return null;
      if (!this.config.editor) {
        if (this.now() < this.config.campaignStart || this.now() >= this.config.campaignEnd || this.now() >= this.config.nextChange) return null;
        return this.phases[0] || null;
      }
      let phase;
      if (this.config.editor && this.previewId) phase = this.phases.find(p => p.id === this.previewId);
      if (!phase && !this.config.automatic) phase = this.phases.find(p => p.key === this.config.manualPhase);
      if (!phase) phase = this.phases.find(p => this.now() >= Date.parse(p.start) && this.now() < Date.parse(p.end));
      if (!phase && this.config.editor) phase = this.phases[0];
      return phase || null;
    }
    bind() {
      const on = (target, name, handler, options = {}) => target.addEventListener(name, handler, { ...options, signal: this.controller.signal });
      on(this, 'click', event => {
        const button = event.target.closest('[data-action]');
        if (!button) return;
        const action = button.dataset.action;
        if (action === 'preview' && this.config.editor) this.open('editor');
        if (action === 'close') this.dialog.close();
        if (action === 'copy') this.copyCode();
      });
      on(this.dialog, 'click', event => {
        if (event.target !== this.dialog) return;
        const box = this.dialog.getBoundingClientRect();
        if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) this.dialog.close();
      });
      on(this.dialog, 'close', () => {
        this.unlockScroll();
        if (!this.config.editor && !this.silentClose) this.recordExposure();
        this.silentClose = false;
      });
      for (const name of ['cart:update', 'cart:updated', 'cart:change', 'cart-section:restored']) {
        on(document, name, () => {
          this.cartTime = 0;
          if (this.dialog.open && this.phase?.mode === 'tier') {
            clearTimeout(this.cartTimer);
            this.cartTimer = setTimeout(() => this.refreshCart(), 250);
          }
        });
      }
      on(window, 'pagehide', () => { this.saveVisitClock(true); this.wasVisible = false; });
      on(window, 'pageshow', event => {
        if (event.persisted) {
          this.loadVisit();
          this.pageReadyAt = performance.now() + 2000;
        } else {
          this.saveVisitClock(true);
        }
        this.wasVisible = !document.hidden;
        this.lastClock = performance.now();
        this.resetSubmit();
        if (this.dialog.open) this.refreshCart();
      });
      on(document, 'visibilitychange', () => {
        this.saveVisitClock(true);
        if (!document.hidden) { this.tick(); if (this.dialog.open) this.refreshCart(); }
      });
      on(this.form, 'submit', event => this.submit(event));
      on(this.querySelector('[data-apply]'), 'click', event => {
        if (this.config.editor) { event.preventDefault(); this.text('[data-status]', this.strings.preview); return; }
        const current = this.choosePhase();
        if (!current || current.id !== this.phase?.id) { event.preventDefault(); this.tick(); return; }
        this.recordExposure();
      });
      if (this.config.editor) {
        on(document, 'shopify:block:select', event => {
          if (!this.phases.some(p => p.id === event.detail.blockId)) return;
          this.previewId = event.detail.blockId;
          this.phase = this.choosePhase();
          this.success = false;
          this.render();
          this.open('editor');
        });
        on(document, 'shopify:section:select', event => {
          if (event.detail.sectionId === this.dataset.sectionId) this.open('editor');
        });
        on(document, 'shopify:section:deselect', event => {
          if (event.detail.sectionId === this.dataset.sectionId && this.dialog.open) this.dialog.close();
        });
      }
    }
    tick() {
      this.saveVisitClock();
      if (document.hidden) return;
      if (!this.config.editor && this.config.enabled && this.now() >= this.config.nextChange && this.now() < this.config.campaignEnd) this.refreshPhase();
      const next = this.choosePhase();
      if (next?.id !== this.phase?.id) {
        this.phase = next;
        this.success = false;
        if (!next) {
          this.silentClose = true;
          if (this.dialog.open) this.dialog.close();
          return;
        }
        this.render();
      }
      if (!this.phase) return;
      if (this.canAutoOpen()) this.open('auto');
    }
    async refreshPhase() {
      if (this.phaseLoading || this.now() - (this.phaseAttempt || 0) < 30000) return;
      this.phaseLoading = true;
      this.phaseAttempt = this.now();
      try {
        const url = new URL(location.href);
        url.hash = '';
        url.searchParams.set('section_id', this.dataset.sectionId);
        url.searchParams.delete('contact_posted');
        const response = await fetch(url.pathname + url.search, { credentials: 'same-origin', cache: 'no-store', signal: this.controller.signal });
        if (!response.ok) return;
        const html = new DOMParser().parseFromString(await response.text(), 'text/html');
        const node = html.querySelector('[data-bfcm-config]');
        if (!node) return;
        const config = JSON.parse(node.textContent);
        if (!Number.isFinite(config.serverTime) || !Array.isArray(config.phases)) return;
        this.config = config;
        this.baseTime = config.serverTime;
        this.started = performance.now();
        this.strings = config.strings;
        this.phases = config.phases.map(p => ({ id: p.id, ...p.settings }));
        this.phase = this.choosePhase();
        this.success = false;
        if (this.phase) this.render();
      } catch {} finally { this.phaseLoading = false; }
    }
    canAutoOpen() {
      if (this.config.editor || !this.config.autoOpen || !this.phase || document.hidden) return false;
      if (this.dialog.open || this.visit.shown) return false;
      if (['signup', 'live'].includes(this.phase.mode) && this.isSubscriber()) return false;
      const key = this.exposureKey();
      const exposedAt = Number(this.read(key) || (this.lastExposureKey === key ? this.lastExposure : 0) || 0);
      if (exposedAt && this.now() - exposedAt < this.config.cooldown * 3600000) return false;
      if (this.visit.activeMs < this.config.delay * 1000 || performance.now() < this.pageReadyAt) return false;
      if (/(^|\/)(cart|checkout|checkouts|account|challenge)(\/|$)/.test(location.pathname)) return false;
      if (document.activeElement?.matches('input, textarea, select, [contenteditable="true"]') || this.otherOverlay()) {
        this.deferUntil = performance.now() + 2000;
        return false;
      }
      return performance.now() >= this.deferUntil;
    }
    otherOverlay() {
      return [...document.querySelectorAll('dialog[open], [aria-modal="true"], .shopify-pc__banner')].some(node => {
        if (node === this.dialog || node.closest('[hidden], [aria-hidden="true"], [inert]')) return false;
        if (node.tagName === 'DIALOG' && !node.hasAttribute('open')) return false;
        const box = node.getBoundingClientRect();
        if (box.width <= 0 || box.height <= 0 || box.bottom <= 0 || box.top >= innerHeight || box.right <= 0 || box.left >= innerWidth) return false;
        for (let parent = node; parent; parent = parent.parentElement) {
          const style = getComputedStyle(parent);
          if (style.display === 'none' || style.visibility === 'hidden' || Number(style.opacity) < .05) return false;
        }
        return true;
      });
    }
    unlockScroll() {
      if (this.scrollLocked) {
        document.documentElement.style.overflow = this.previousOverflow;
        this.scrollLocked = false;
      }
    }
    render() {
      const p = this.phase;
      if (!p) return;
      const early = p.mode === 'signup' || p.mode === 'live';
      const tier = p.mode === 'tier';
      this.dialog.dataset.kind = p.mode;
      this.text('[data-eyebrow]', p.eyebrow);
      this.text('[data-title]', this.format(p.title));
      this.text('[data-body]', this.format(p.body));
      this.text('[data-date]', p.date_label);
      this.text('[data-mode-label]', early ? this.strings.subscribers : this.strings.public_offer);
      this.querySelector('[data-value-wrap]').hidden = p.mode === 'signup';
      this.text('[data-value]', tier ? p.tier : p.discount);
      this.querySelector('[data-extra]').hidden = !this.config.baseReduction;
      this.querySelector('[data-tiers]').hidden = !tier;
      this.text('[data-low-label]', this.format(this.strings.one_item));
      this.text('[data-high-label]', this.format(this.strings.more_items));
      const prefix = this.config.baseReduction ? this.strings.extra[0] + this.strings.extra.slice(1).toLowerCase() + ' ' : '';
      this.text('[data-low-rate]', prefix + p.discount + '%');
      this.text('[data-high-rate]', prefix + p.tier + '%');
      this.querySelector('[data-tier-low]').removeAttribute('data-current');
      this.querySelector('[data-tier-high]').removeAttribute('data-current');
      this.querySelector('[data-cart-note]').hidden = true;
      const total = this.querySelector('[data-total]');
      total.hidden = !this.config.baseReduction || p.mode === 'signup';
      const totalRate = rate => Number((100 - (100 - this.config.baseReduction) * (100 - rate) / 100).toFixed(2));
      this.text('[data-total]', this.format(tier ? this.strings.total_tier : this.strings.total, { total: totalRate(p.discount), total_tier: totalRate(p.tier), base: this.config.baseReduction }));
      this.querySelector('[data-public]').hidden = early;
      const code = String(p.code || '').trim();
      this.text('[data-code]', code);
      this.text('[data-action="copy"]', this.strings.copy);
      this.querySelector('[data-code-row]').hidden = !code;
      this.text('[data-apply-label]', code ? p.button : this.strings.shop);
      const apply = this.querySelector('[data-apply]');
      const redirect = this.returnPath();
      apply.href = code ? '/discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent(redirect) : this.safeShopUrl();
      this.text('[data-submit-label]', early ? p.button : this.strings.subscribe);
      this.form.querySelector('[data-tags]').value = 'newsletter, BFCM_2026, ' + (early ? this.config.earlyTag : this.config.publicTag);
      this.text('[data-status]', '');
      this.querySelector('[data-success]').hidden = !this.success;
      this.querySelector('[data-known]').hidden = !(early && this.isSubscriber() && !this.success);
      this.text('[data-known]', p.mode === 'live' ? this.strings.known_live : this.strings.known_early);
      const newsletter = this.querySelector('[data-newsletter]');
      newsletter.hidden = !!this.success || this.isSubscriber() || (!early && !this.config.showEmail);
      newsletter.open = early;
      newsletter.toggleAttribute('data-primary', early);
      if (this.dialog.open) this.refreshCart();
    }
    safeShopUrl() {
      try {
        const url = new URL(this.config.shopUrl, location.origin);
        return url.origin === location.origin ? url.pathname + url.search : this.config.root + 'collections/all';
      } catch { return this.config.root + 'collections/all'; }
    }
    returnPath() {
      if (/(^|\/)(contact|challenge|account|checkout|checkouts)(\/|$)/.test(location.pathname)) return this.safeShopUrl();
      const url = new URL(location.href);
      for (const key of ['contact_posted', 'customer_posted', 'form_type', 'return_to']) url.searchParams.delete(key);
      return url.pathname + url.search;
    }
    cleanReturnUrl() {
      try {
        const url = new URL(location.href);
        for (const key of ['contact_posted', 'customer_posted', 'form_type', 'return_to']) url.searchParams.delete(key);
        if (url.hash === '#' + this.config.formId) url.hash = '';
        history.replaceState(history.state, '', url.pathname + url.search + url.hash);
      } catch {}
    }
    open(reason) {
      if (!this.phase || this.dialog.open || !this.dialog.showModal) return;
      if (reason === 'auto' && this.otherOverlay()) return;
      if (reason !== 'result') this.render();
      this.dialog.showModal();
      this.previousOverflow = document.documentElement.style.overflow;
      this.scrollLocked = true;
      document.documentElement.style.overflow = 'hidden';
      this.dialog.scrollTop = 0;
      this.querySelector('[data-title]').focus({ preventScroll: true });
      if (!this.config.editor) this.recordExposure();
      this.refreshCart();
    }
    async refreshCart() {
      if (!this.phase || this.phase.mode !== 'tier' || !this.dialog.open || this.config.editor || this.cartLoading) return;
      if (this.cartTime && this.now() - this.cartTime < 5000) return;
      this.cartLoading = true;
      try {
        const response = await fetch(this.config.root + 'cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' }, signal: this.controller.signal });
        if (!response.ok) return;
        const cart = await response.json();
        if (!Array.isArray(cart.items) || this.phase?.mode !== 'tier') return;
        const count = cart.items.filter(item => !item.gift_card).reduce((sum, item) => sum + (Number(item.quantity) || 0), 0);
        this.cartTime = this.now();
        this.querySelector('[data-tier-low]').toggleAttribute('data-current', count > 0 && count < this.phase.minimum);
        this.querySelector('[data-tier-high]').toggleAttribute('data-current', count >= this.phase.minimum);
        const message = count >= this.phase.minimum ? this.strings.cart_ready : (count === this.phase.minimum - 1 ? this.strings.cart_one_more : this.strings.cart_more);
        this.text('[data-cart-note]', this.format(message, { remaining: Math.max(0, this.phase.minimum - count), extra: this.config.baseReduction ? this.strings.extra.toLowerCase() + ' ' : '' }));
        this.querySelector('[data-cart-note]').hidden = count === 0;
      } catch {} finally { this.cartLoading = false; }
    }
    async copyCode() {
      const code = String(this.phase?.code || '').trim();
      if (!code) return;
      try {
        await navigator.clipboard.writeText(code);
        this.text('[data-action="copy"]', this.strings.copied);
        this.text('[data-status]', this.strings.copied);
      } catch {
        const range = document.createRange();
        range.selectNodeContents(this.querySelector('[data-code]'));
        const selection = window.getSelection();
        selection.removeAllRanges();
        selection.addRange(range);
        this.text('[data-status]', this.strings.copy_manual);
      }
    }
    submit(event) {
      if (!this.form.checkValidity()) { event.preventDefault(); this.form.reportValidity(); return; }
      if (this.config.editor) { event.preventDefault(); this.showSuccess(); return; }
      const current = this.choosePhase();
      if (!current || current.id !== this.phase?.id) { event.preventDefault(); this.tick(); this.text('[data-status]', this.strings.changed); return; }
      this.write('pending', { time: this.now(), phase: this.phase.id }, true);
      const button = this.form.querySelector('[type="submit"]');
      button.disabled = true;
      this.text('[data-submit-label]', this.strings.sending);
      clearTimeout(this.submitTimer);
      this.submitTimer = setTimeout(() => this.resetSubmit(), 20000);
    }
    resetSubmit() {
      if (!this.phase || !this.form) return;
      this.form.querySelector('[type="submit"]').disabled = false;
      this.text('[data-submit-label]', ['signup', 'live'].includes(this.phase.mode) ? this.phase.button : this.strings.subscribe);
    }
    showSuccess() {
      this.success = true;
      this.querySelector('[data-newsletter]').hidden = true;
      this.querySelector('[data-known]').hidden = true;
      this.querySelector('[data-success]').hidden = false;
      const key = this.phase.mode === 'signup' ? 'signup_success_early' : this.phase.mode === 'live' ? 'signup_success_live' : 'signup_success_public';
      this.text('[data-success-body]', this.config.editor ? this.strings.preview : this.strings[key]);
      this.resetSubmit();
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cultivator-mystery-discount"] && !Shopify.designMode) return;
  try {
    

(() => {
  if (customElements.get('cultivator-mystery-discount')) return;
  const entryUrl = new URL(location.href);
  let claimed = false;
  const reducedMotion = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const sameCode = (a, b) => String(a || '').trim().toUpperCase() === String(b || '').trim().toUpperCase();
  const rootUrl = () => `${(window.Shopify?.routes?.root || '/').replace(/\/$/, '')}/`;
  const publish = (name, data) => {
    try { window.Shopify?.analytics?.publish?.(name, { path: location.pathname, ...data }); } catch {}
  };
  const fetchJson = async (url, options = {}) => {
    const controller = new AbortController();
    const timer = setTimeout(() => controller.abort(), 6000);
    try {
      const response = await fetch(url, {
        credentials: 'same-origin', cache: 'no-store', ...options,
        headers: { Accept: 'application/json', ...options.headers }, signal: controller.signal,
      });
      if (!response.ok) throw new Error(`HTTP ${response.status}`);
      return await response.json();
    } finally { clearTimeout(timer); }
  };

  class CultivatorMysteryDiscount extends HTMLElement {
    async connectedCallback() {
      this.abort?.abort();
      this.abort = new AbortController();
      const { signal } = this.abort;
      this.dialog = this.querySelector('dialog');
      if (!this.dialog) return;
      try { this.config = JSON.parse(this.dataset.config); }
      catch { return; }
      this.entryUrl = this.readEntryUrl();
      this.code = '';
      this.designMode = this.hasAttribute('data-design-mode');
      this.sectionId = this.dataset.sectionId;
      this.endsAt = this.parseEnd(this.config.endsAt);
      this.invalidEnd = Boolean(this.config.endsAt) && this.endsAt === null;
      this.applied = this.querySelector('[data-cultivator-md-applied]');
      this.appliedText = this.querySelector('[data-cultivator-md-applied-text]');
      this.appliedSub = this.querySelector('[data-cultivator-md-applied-sub]');
      this.announcement = this.querySelector('[data-cultivator-md-announcement]');
      this.countdown = this.querySelector('[data-cultivator-md-countdown]');
      this.dialog.addEventListener('click', this.onClick, { signal });
      this.dialog.addEventListener('cancel', (event) => { event.preventDefault(); this.close('escape'); }, { signal });
      this.dialog.addEventListener('close', () => this.unlockScroll(), { signal });
      if (this.designMode) { this.setupEditor(signal); return; }
      const trigger = await this.findTrigger();
      if (signal.aborted || !this.isConnected || !trigger || claimed) return;
      this.trigger = trigger;
      this.code = trigger.code;
      this.recoveryUrl = this.config.allowRecovery ? this.findRecovery() : null;
      if (!this.config.active || this.invalidEnd || this.expired()) {
        if (this.recoveryUrl) {
          claimed = true;
          this.cleanUrl();
          location.replace(this.recoveryUrl.href);
        }
        return;
      }
      claimed = true;
      this.cleanUrl();
      this.applyPromise = this.recoveryUrl
        ? Promise.resolve({ state: 'recovery', cart: null })
        : this.invalidRecovery
          ? Promise.resolve({ state: 'invalid-recovery', cart: null })
          : this.applyCode();
      const start = () => { this.openTimer = setTimeout(() => this.open(this.trigger.type), 350); };
      if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true, signal });
      else start();
    }

    disconnectedCallback() {
      this.abort?.abort();
      ['openTimer', 'revealTimer', 'statusTimer', 'closeTimer', 'slowTimer'].forEach((key) => clearTimeout(this[key]));
      clearInterval(this.tick);
      if (this.dialog?.open) this.dialog.close();
      this.unlockScroll();
    }

    parseEnd(value) {
      if (!value) return null;
      const match = /^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2})(?::(\d{2}))?(Z|[+-]\d{2}:\d{2})$/.exec(value);
      if (!match) return null;
      const [, year, month, day, hour, minute, second = '00'] = match;
      const days = new Date(Date.UTC(Number(year), Number(month), 0)).getUTCDate();
      if (+month < 1 || +month > 12 || +day < 1 || +day > days || +hour > 23 || +minute > 59 || +second > 59) return null;
      const time = Date.parse(value);
      return Number.isFinite(time) ? time : null;
    }

    expired() { return this.endsAt !== null && Date.now() >= this.endsAt; }

    readEntryUrl() {
      const url = new URL(entryUrl.href);
      const param = String(this.config.param || 'mystery').toLowerCase();
      const explicit = [...url.searchParams].filter(([key]) => key.toLowerCase() === param);
      if (url.hash || explicit.length !== 1) return url;
      const [key, value] = explicit[0];
      const marker = value.indexOf('#cz-recover=');
      if (marker < 1 || value.indexOf('#', marker + 1) !== -1) return url;
      const fragment = value.slice(marker + 1);
      const parts = [...new URLSearchParams(fragment)];
      if (parts.length !== 1 || parts[0][0] !== 'cz-recover' || !parts[0][1]) return url;
      url.searchParams.set(key, value.slice(0, marker));
      url.hash = fragment;
      return url;
    }

    async matchesCode(candidate) {
      const normalized = String(candidate || '').trim().toUpperCase();
      const expected = String(this.config.codeHash || '').toLowerCase();
      if (!normalized || !/^[a-f0-9]{64}$/.test(expected) || !globalThis.crypto?.subtle) return false;
      try {
        const buffer = await globalThis.crypto.subtle.digest('SHA-256', new TextEncoder().encode(normalized));
        const actual = Array.from(new Uint8Array(buffer), (byte) => byte.toString(16).padStart(2, '0')).join('');
        return actual === expected;
      } catch { return false; }
    }

    async findTrigger() {
      const param = String(this.config.param || 'mystery').toLowerCase();
      const entries = [...this.entryUrl.searchParams];
      const explicit = entries.filter(([key]) => key.toLowerCase() === param);
      if (explicit.length) {
        const candidate = String(explicit[0][1] || '').trim();
        if (!candidate || !explicit.every(([, value]) => sameCode(value, candidate))) return null;
        return await this.matchesCode(candidate) ? { type: 'link', code: candidate } : null;
      }
      const normalize = (value) => String(value || '').replace(/\+/g, ' ').replace(/\s+/g, ' ').trim();
      const campaign = normalize(this.config.emailCampaign);
      const allowedIds = String(this.config.emailActivityIds || '').split(/[\s,;]+/).filter((id) => /^\d+$/.test(id));
      if (!campaign && !allowedIds.length) return null;
      const read = (name) => entries.find(([key]) => key.toLowerCase() === name)?.[1] || '';
      if (read('utm_source').toLowerCase() !== 'shopify_email' || read('utm_medium').toLowerCase() !== 'email') return null;
      const incomingCampaign = normalize(read('utm_campaign'));
      const activityValues = entries.filter(([key]) => key.toLowerCase() === 'se_activity_id').map(([, value]) => value.trim());
      const activityId = activityValues[0] || '';
      const campaignId = /_(\d+)$/.exec(incomingCampaign)?.[1] || '';
      if (activityValues.length && (!/^\d+$/.test(activityId) || !activityValues.every((value) => value === activityId) || (campaignId && campaignId !== activityId))) return null;
      const matchedId = allowedIds.includes(activityId || campaignId) ? activityId || campaignId : '';
      if (!matchedId && (!campaign || incomingCampaign !== campaign)) return null;
      const emailKey = matchedId ? `activity:${matchedId}` : campaign;
      let cart;
      try { cart = await fetchJson(`${rootUrl()}cart.js`); } catch { return null; }
      for (const item of Array.isArray(cart.discount_codes) ? cart.discount_codes : []) {
        const candidate = String(item.code || '').trim();
        if (!await this.matchesCode(candidate)) continue;
        const storageKey = `cultivator-md-campaign:${candidate.toUpperCase()}:${emailKey}:${this.config.endsAt || ''}`;
        try { if (sessionStorage.getItem(storageKey) === '1') return null; } catch {}
        return { type: 'email', code: candidate, storageKey };
      }
      return null;
    }

    findRecovery() {
      const fragments = new URLSearchParams(this.entryUrl.hash.slice(1));
      const values = fragments.getAll('cz-recover');
      if (!values.length) return null;
      this.invalidRecovery = true;
      if (values.length !== 1 || !values[0]) return null;
      try {
        const url = new URL(values[0]);
        const origins = new Set([location.origin]);
        if (this.config.storeUrl) origins.add(new URL(this.config.storeUrl).origin);
        if (this.config.shopDomain) origins.add(new URL(`https://${this.config.shopDomain}`).origin);
        if (url.protocol !== 'https:' || url.username || url.password || !origins.has(url.origin)) return null;
        if (!/^\/(?:\d+\/)?checkouts\/[^?#]+$/.test(url.pathname)) return null;
        this.invalidRecovery = false;
        return url;
      } catch { return null; }
    }

    recoveryDestination() {
      if (!this.recoveryUrl) return null;
      const url = new URL(this.recoveryUrl.href);
      if (!this.expired()) {
        url.searchParams.set('discount', this.code);
      }
      return url.href;
    }

    cleanUrl() {
      try {
        const url = new URL(location.href);
        for (const key of [...url.searchParams.keys()]) {
          if (key.toLowerCase() === this.config.param.toLowerCase()) url.searchParams.delete(key);
        }
        const fragments = new URLSearchParams(url.hash.slice(1));
        if (fragments.has('cz-recover')) {
          fragments.delete('cz-recover');
          url.hash = fragments.toString();
        }
        history.replaceState(history.state, '', url.href);
      } catch {}
    }

    async applyCode() {
      let result = { state: 'fallback', cart: null };
      try {
        let cart = await fetchJson(`${rootUrl()}cart.js`);
        const existing = Array.isArray(cart.discount_codes) ? cart.discount_codes : [];
        let discount = existing.find((item) => sameCode(item.code, this.code));
        if (!discount) {
          if (this.expired()) return { state: 'expired', cart };
          const codes = [...new Set(existing.map((item) => item.code).filter(Boolean))];
          if (codes.length >= 5) return result;
          cart = await fetchJson(`${rootUrl()}cart/update.js`, {
            method: 'POST', headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ discount: [...codes, this.code].join(',') }),
          });
          discount = (cart.discount_codes || []).find((item) => sameCode(item.code, this.code));
        }
        if (discount?.applicable === true) result = { state: 'applied', cart };
        else if (discount && cart.item_count === 0) result = { state: 'saved', cart };
        else result = { state: 'fallback', cart };
        if (discount) this.refreshCart(cart);
      } catch {}
      if (this.expired()) result.state = 'expired';
      publish('cultivator_mystery_applied', { code: this.code, state: result.state });
      return result;
    }

    async refreshCart(cart) {
      try {
        if (!cart?.item_count) return;
        const { DiscountUpdateEvent } = await import('@theme/events');
        document.dispatchEvent(new DiscountUpdateEvent(cart, `cultivator-mystery-${this.sectionId}`));
      } catch {}
    }

    open(trigger) {
      if (!this.isConnected || this.dialog.open || (!this.designMode && this.expired())) return;
      clearTimeout(this.closeTimer);
      this.closing = false;
      this.revealed = false;
      this.dialog.classList.remove('is-revealed', 'is-closing', 'is-intro', 'is-animated', 'has-status');
      this.applied.dataset.state = 'pending';
      this.appliedText.textContent = '';
      this.appliedSub.textContent = '';
      this.announcement.hidden = true;
      if (this.recoveryUrl) this.querySelector('[data-cultivator-md-cta]').textContent = this.config.recoveryButton;
      this.previousFocus = document.activeElement;
      try { this.dialog.showModal(); } catch { return; }
      if (!this.designMode && this.trigger?.storageKey) {
        try { sessionStorage.setItem(this.trigger.storageKey, '1'); } catch {}
      }
      document.documentElement.classList.add('cultivator-md-scroll-lock');
      this.startCountdown();
      if (!this.designMode) publish('cultivator_mystery_view', { code: this.code, trigger });
      if (reducedMotion()) { this.reveal('instant'); return; }
      this.dialog.classList.add('is-intro', 'is-animated');
      this.revealTimer = setTimeout(() => this.reveal('auto'), 1350);
    }

    reveal(method) {
      if (this.revealed || !this.dialog.open || this.closing) return;
      this.revealed = true;
      clearTimeout(this.revealTimer);
      this.dialog.classList.add('is-revealed');
      if (!this.designMode) publish('cultivator_mystery_reveal', { code: this.code, method });
      this.statusTimer = setTimeout(() => this.showStatus(), method === 'instant' ? 0 : 700);
    }

    async showStatus() {
      if (this.designMode) { this.setStatus('applied', this.config.appliedText, this.config.appliedNote); return; }
      this.slowTimer = setTimeout(() => this.setStatus('applying', this.config.applyingText), 150);
      const result = await this.applyPromise;
      clearTimeout(this.slowTimer);
      if (this.expired() || result?.state === 'expired') this.setStatus('expired', this.config.expiredText);
      else if (result?.state === 'recovery') this.setStatus('recovery', this.config.recoveryText, this.config.recoveryNote);
      else if (result?.state === 'invalid-recovery') this.setStatus('fallback', this.config.invalidRecovery);
      else if (result?.state === 'applied') this.setStatus('applied', this.config.appliedText, this.config.appliedNote);
      else if (result?.state === 'saved') this.setStatus('saved', this.config.savedText, this.config.savedNote);
      else this.setStatus('fallback', this.config.fallbackText, this.config.fallbackNote);
    }

    setStatus(state, text, sub = '') {
      if (!this.isConnected || !this.dialog.open || this.closing) return;
      this.applied.dataset.state = state;
      this.appliedText.textContent = text || '';
      this.appliedSub.textContent = sub;
      this.announcement.hidden = state === 'expired';
      this.dialog.classList.add('has-status');
    }

    timeLeft(ms) {
      const total = Math.floor(ms / 60000);
      if (total < 1) return this.config.lessThanMinute;
      const days = Math.floor(total / 1440);
      const hours = Math.floor(total % 1440 / 60);
      const minutes = total % 60;
      const unit = (number, name) => {
        try { return new Intl.NumberFormat(this.config.locale || 'en', { style: 'unit', unit: name, unitDisplay: 'long' }).format(number); }
        catch { return `${number}${{ day: 'd', hour: 'h', minute: 'm' }[name]}`; }
      };
      if (days) return [unit(days, 'day'), hours ? unit(hours, 'hour') : ''].filter(Boolean).join(' ');
      if (hours) return [unit(hours, 'hour'), minutes ? unit(minutes, 'minute') : ''].filter(Boolean).join(' ');
      return unit(minutes, 'minute');
    }

    startCountdown() {
      clearInterval(this.tick);
      this.countdown.hidden = !this.config.showCountdown || this.endsAt === null;
      if (this.endsAt === null || this.designMode && this.invalidEnd) return;
      const update = () => {
        if (this.expired()) {
          clearInterval(this.tick);
          if (!this.designMode) this.setStatus('expired', this.config.expiredText);
          this.countdown.textContent = this.config.expiredText;
          return;
        }
        this.countdown.textContent = this.config.countdownText.replace('[time]', this.timeLeft(this.endsAt - Date.now()));
      };
      update();
      if (!this.expired()) this.tick = setInterval(update, 1000);
    }

    close(method) {
      if (!this.dialog.open || this.closing) return;
      this.closing = true;
      ['revealTimer', 'statusTimer', 'slowTimer'].forEach((key) => clearTimeout(this[key]));
      clearInterval(this.tick);
      if (!this.designMode) publish('cultivator_mystery_close', { code: this.code, method });
      const finish = () => {
        this.dialog.close();
        this.dialog.classList.remove('is-closing', 'is-intro', 'is-revealed', 'is-animated', 'has-status');
        this.unlockScroll();
        this.closing = false;
        if (this.previousFocus?.isConnected) this.previousFocus.focus({ preventScroll: true });
      };
      if (reducedMotion()) finish();
      else { this.dialog.classList.add('is-closing'); this.closeTimer = setTimeout(finish, 220); }
    }

    onClick = async (event) => {
      if (event.target === this.dialog) { this.close('backdrop'); return; }
      const target = event.target instanceof Element ? event.target : null;
      if (!target) return;
      if (target.closest('[data-cultivator-md-close]')) { this.close('button'); return; }
      if (target.closest('[data-cultivator-md-tag]')) { this.reveal('tap'); return; }
      const cta = target.closest('[data-cultivator-md-cta]');
      if (!cta) return;
      event.preventDefault();
      if (cta.getAttribute('aria-busy') === 'true') return;
      if (this.designMode) { this.close('editor'); return; }
      publish('cultivator_mystery_cta', { code: this.code });
      cta.setAttribute('aria-busy', 'true');
      await this.applyPromise;
      cta.removeAttribute('aria-busy');
      if (!this.isConnected || !this.dialog.open || this.closing) return;
      this.close('cta');
      const recovery = this.recoveryDestination();
      if (recovery) location.assign(recovery);
      else if (!this.invalidRecovery && cta instanceof HTMLAnchorElement) location.assign(cta.href);
    };

    unlockScroll() {
      if (!document.querySelector('cultivator-mystery-discount dialog[open]')) document.documentElement.classList.remove('cultivator-md-scroll-lock');
    }

    setupEditor(signal) {
      const key = `cultivator-md-editor:${this.sectionId}`;
      const remember = (on) => { try { on ? sessionStorage.setItem(key, '1') : sessionStorage.removeItem(key); } catch {} };
      document.addEventListener('shopify:section:select', (event) => {
        if (event.detail?.sectionId !== this.sectionId) return;
        remember(true); this.open('editor');
      }, { signal });
      document.addEventListener('shopify:section:deselect', (event) => {
        if (event.detail?.sectionId !== this.sectionId) return;
        remember(false); this.close('editor');
      }, { signal });
      const messages = [];
      if (!this.config.active) messages.push(this.config.editorDisabled);
      if (this.invalidEnd) messages.push(this.config.editorInvalidEnd);
      else if (this.expired()) messages.push(this.config.editorExpired);
      const note = this.querySelector('[data-cultivator-md-editor-note]');
      if (note && messages.length) { note.textContent = messages.join(' '); note.hidden = false; }
      try { if (sessionStorage.getItem(key) === '1') this.openTimer = setTimeout(() => this.open('editor'), 150); } catch {}
    }
  }
  customElements.define('cultivator-mystery-discount', CultivatorMysteryDiscount);
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
